import { Builder } from '@builder.io/react';

import { Slider } from './index';

Builder.registerComponent(Slider, {
  name: 'Summit Slider',
  inputs: [
    {
      name: 'images',
      type: 'list',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png'],
          helperText: 'Images should be squared.'
        },
        {
          name: 'alt',
          type: 'string'
        }
      ]
    }
  ]
});
